import { Location, NgClass } from '@angular/common';
import { AfterViewInit, Component, ComponentRef, OnDestroy, Type, ViewChild, ViewContainerRef, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { APP_ROUTE_CONSTANTS, LANGUAGE_SWITCHER_CONFIG, LOGIN_LOGO_COMPONENT, NAVIGATION_CONFIG, NavigationConfig } from '@shared/core';
import { LanguageSwitcherComponent } from '../language-switcher/language-switcher.component';

export interface ThmModalSettings {
    showClose: boolean;
    title: string;
    returnUrl?: string;
    fragment?: string;
}

@Component({
    selector: 'shared-default-navigation',
    imports: [RouterModule, LanguageSwitcherComponent, NgClass],
    templateUrl: './default-navigation.component.html',
})
export class DefaultNavigationComponent implements OnDestroy, AfterViewInit {
    @ViewChild('logoContainer', { read: ViewContainerRef }) logoContainer!: ViewContainerRef;
    private readonly logoComponent = inject(LOGIN_LOGO_COMPONENT, { optional: true }) as Type<Component>;
    readonly config: NavigationConfig = inject(NAVIGATION_CONFIG);
    private logoRef: ComponentRef<Component> | null = null;
    private readonly router = inject(Router);
    private readonly location = inject(Location);
    private readonly ts = {
        showClose: false,
        title: '',
    } as ThmModalSettings;
    private readonly languageSwitcherConfig = inject(LANGUAGE_SWITCHER_CONFIG, { optional: true });
    readonly appRouteConstants = inject(APP_ROUTE_CONSTANTS);
    showBackButton = false;
    private readonly blockedRoutes = ['/main/telemedicine/session', '/main/telemedicine/lobby']; // TODO: better solution for blocked routes
    readonly isLanguageSwitcherEnabled = signal(this.languageSwitcherConfig?.enabled ?? false);

    constructor() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (event.urlAfterRedirects.includes(this.appRouteConstants.home)) {
                    this.showBackButton = false;
                } else {
                    this.showBackButton = true;
                }
            }
        });
    }

    ngAfterViewInit() {
        if (this.logoComponent && this.logoContainer) {
            this.logoRef = this.logoContainer.createComponent(this.logoComponent);
            this.logoRef.setInput('scale', 0.6);
        }
    }

    ngOnDestroy() {
        if (this.logoRef) {
            this.logoRef.destroy();
        }
    }

    goBack(): void {
        if (this.ts?.returnUrl && this.ts.returnUrl !== this.router.url && !this.blockedRoutes.includes(this.router.url)) {
            this.router.navigate([this.ts.returnUrl], { fragment: this.ts.fragment });
        } else if (!this.blockedRoutes.includes(this.router.url)) {
            this.location.back();
        } else {
            this.router.navigate([this.appRouteConstants.home]);
        }
    }

    goHome(): void {
        this.router.navigate([this.appRouteConstants.home]);
    }
}
